import { EtxeTokenVaultActions } from '../business/etxe/token-vault';

export type TokenVaultActions =
  | UserSmsTokenVaultActions
  | UserEmailTokenVaultActions
  | PublicTokenVaultActions
  | UserTwoFATokenVaultActions
  | UserRegistrationConfirmationTokenVaultActions
  | BetaRegistrationTokenVaultActions
  | EtxeTokenVaultActions;

export enum UserRegistrationConfirmationTokenVaultActions {
  USER_REGISTRATION_EMAIL_CONFIRMATION = 'user_registration_email_confirmation',
  USER_REGISTRATION_MOBILE_CONFIRMATION = 'user_registration_mobile_confirmation',
}

export enum BetaRegistrationTokenVaultActions {
  BETA_REGISTRATION_EMAIL_CONFIRMATION = 'beta_registration_email_confirmation',
}

export enum UserEmailTokenVaultActions {
  USER_CHANGE_EMAIL = 'user_change_email',
  USER_TWO_FA_CHANGE_EMAIL = 'user_two_fa_change_email',
}

export enum PublicTokenVaultActions {
  USER_PASSWORD_LOST = 'user_password_lost',
}

export enum UserSmsTokenVaultActions {
  USER_CHANGE_MOBILE = 'user_change_mobile',
  USER_TWO_FA_CHANGE_MOBILE = 'user_two_fa_change_mobile',
}

export enum UserTwoFATokenVaultActions {
  DELETE_ACCOUNT = 'user_delete_account',
  DEACTIVATE_ACCOUNT = 'user_deactivate_account',
  USER_TWO_FA_CHANGE_PASSWORD = 'user_two_fa_change_password',
  USER_TWO_FA_CHANGE_EMAIL = UserEmailTokenVaultActions.USER_TWO_FA_CHANGE_EMAIL,
  USER_TWO_FA_CHANGE_MOBILE = UserSmsTokenVaultActions.USER_TWO_FA_CHANGE_MOBILE,
}

export const AllTokenVaultActions = {
  ...PublicTokenVaultActions,
  ...UserSmsTokenVaultActions,
  ...UserRegistrationConfirmationTokenVaultActions,
  ...UserEmailTokenVaultActions,
  ...UserTwoFATokenVaultActions,
  ...BetaRegistrationTokenVaultActions,
  ...EtxeTokenVaultActions,
} as const;
